// Generated by tools/as3-to-ts from work/decomp/main/scripts/com/adobe/utils/IntUtil.as; hand-edits allowed (see docs/architecture.md)

import * as as3 from '../../../runtime/as3';

export class IntUtil {
  private static hexChars: any = "0123456789abcdef";

  constructor() {
  }

  static rol(param1: number, param2: number): number {
    param1 = as3.int(param1);
    param2 = as3.int(param2);
    return param1 << param2 | param1 >>> 32 - param2;
  }

  static ror(param1: number, param2: number): number {
    param1 = as3.int(param1);
    param2 = as3.int(param2);
    let _loc3_: number = as3.int(32 - param2);
    return as3.uint(param1 << _loc3_ | param1 >>> 32 - _loc3_);
  }

  static toHex(param1: number, param2: boolean = false): any {
    param1 = as3.int(param1);
    param2 = Boolean(param2);
    let _loc4_: number = 0;
    let _loc5_: number = 0;
    let _loc3_: any = "";
    if (param2) {
      _loc4_ = 0;
      while (_loc4_ < 4) {
        _loc3_ += IntUtil.hexChars.charAt(param1 >> (3 - _loc4_) * 8 + 4 & 0x0F) + IntUtil.hexChars.charAt(param1 >> (3 - _loc4_) * 8 & 0x0F);
        _loc4_ = as3.int(_loc4_ + 1);
      }
    } else {
      _loc5_ = 0;
      while (_loc5_ < 4) {
        _loc3_ += IntUtil.hexChars.charAt(param1 >> _loc5_ * 8 + 4 & 0x0F) + IntUtil.hexChars.charAt(param1 >> _loc5_ * 8 & 0x0F);
        _loc5_ = as3.int(_loc5_ + 1);
      }
    }
    return _loc3_;
  }
}
